import { Theme } from '../features/setting/setting.def.ts'
import echartsLightTheme from '../styles/echarts/echarts-theme-light.json'
import echartsDarkTheme from '../styles/echarts/echarts-theme-dark.json'

export function convertPxToNumber(value?: string) {
  if (value) {
    return parseFloat(value.replace('px', ''))
  }
}

export const isV2Ready = false

export function isDev(): boolean {
  return import.meta.env.VITE_ENVIRONMENT === 'development'
}

export function isStaging(): boolean {
  return import.meta.env.VITE_ENVIRONMENT === 'staging'
}

export function isProd(): boolean {
  return import.meta.env.VITE_ENVIRONMENT === 'production'
}

// FAQ base URL. Production points at the root path, all other environments
// (development, staging, etc.) use the `dev` sub-path.
export const FAQ_BASE_URL = isProd()
  ? 'https://asset.polymerideya.com/faq'
  : 'https://asset.polymerideya.com/faq/dev'

export const isIppon = import.meta.env.VITE_PRODUCTION === '1ppon'
export const isAuth0 = import.meta.env.VITE_IS_AUTH0 === 'auth0'

export const getEchartsTheme = (colorTheme: Theme) =>
  colorTheme === Theme.Dark ? echartsDarkTheme : echartsLightTheme

export const isInternalWebsite = window.location.hostname.includes('internal')
